import Env from '../Env';

export const cashSupportEmail = () => {
  return Env.getCashSupportEmail();
};
